import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Channels {
  user: string;
  conversations: string[];
}

interface RealtimeResponse {
  identity: string;
  token: string;
  channels: Channels;
}

type UserId = number | 'me';

export type GetRealtimeTokenCall = (userId: UserId) => Promise<{
  data: RealtimeResponse;
  status: number;
}>;

export default (makeCall: MakeCall) => (userId: UserId) =>
  makeCall<RealtimeResponse>('GET', `${APIV2_URL}/user/${userId}/realtime`);
